import React from "react";

export interface TableRowProps {
	label: string;
}

export const TableRow: React.FC<React.PropsWithChildren<TableRowProps>> = ({ label, children }) => (
	<div className="col-span-full grid grid-cols-subgrid items-start break-all border-0 border-grey-200 border-t border-solid py-2 first:border-t-0">
		<div className="px-4">{label}</div>

		<div className="flex flex-col items-start gap-1 px-4">{children}</div>
	</div>
);
